/**
 * Textos da tela "Certificados e carimbo" (E157.F3, GUS-157, ADR-0107 §2.7): por peça, o que o
 * exame conferiu na assinatura embutida, na cadeia, na revogação, no carimbo, no certificado de
 * atributo, nos códigos lidos e na aparência — com a fonte de cada fato e os detalhes técnicos por
 * expansão. A leitura de cada linha vem do servidor, no vocabulário do documento emitido.
 */
export const ptBRCertificados = {
  titulo: 'Certificados e carimbo',
  subtitulo:
    'O que o exame conferiu em cada documento: a assinatura embutida, a cadeia de confiança, a revogação na data pertinente, o carimbo do tempo, o certificado de atributo, os códigos lidos das páginas e a aparência de assinatura. Cada linha diz a leitura ou a situação e de onde o fato saiu.',
  abrir: 'Certificados e carimbo',
  voltar: 'Voltar à revisão',
  reverLeitura: 'Rever leitura de um campo',
  carregando: 'Carregando a conferência dos certificados…',
  vazio: 'O caso ainda não tem documento contestado. A conferência aparece aqui depois do exame.',
  erro: 'Não foi possível carregar a conferência dos certificados. Tente novamente.',
  semPermissao: 'A conferência dos certificados é da equipe que atende o caso.',
  naoEncontrado: 'Caso não encontrado ou fora do seu alcance.',
  tentarDeNovo: 'Tentar de novo',
  peca: {
    titulo: 'Documento {letra} — {nome}',
    semLetra: '{nome}',
    semExame: 'Documento ainda não verificado. As linhas aparecem depois do exame.',
    regua: 'Verificado com a régua {regua}.',
    veredito: 'Assinatura digital: {veredito}.',
    campo: 'campo {campo}',
  },
  colunas: {
    ponto: 'Ponto',
    leitura: 'Leitura ou situação',
    fonte: 'Fonte',
  },
  ponto: {
    assinatura_embutida: 'Assinatura embutida',
    cadeia_de_confianca: 'Cadeia de confiança',
    revogacao_na_data_pertinente: 'Revogação na data pertinente',
    carimbo_do_tempo: 'Carimbo do tempo',
    certificado_de_atributo: 'Certificado de atributo',
    codigos_lidos: 'Códigos lidos das páginas',
    aparencia: 'Aparência de assinatura',
  },
  situacao: {
    confere: 'Confere',
    nao_confere: 'Não confere',
    ausente: 'Ausente',
    nao_conferivel: 'Não conferível',
    nao_executado: 'Não executado',
  },
  veredito: {
    confirmada: 'confirmada',
    nao_confirmada: 'não confirmada',
    nao_foi_possivel_confirmar: 'não foi possível confirmar',
    nao_se_aplica: 'não se aplica',
  },
  detalhes: {
    abrir: 'Ver fonte e detalhes técnicos',
    fechar: 'Ocultar fonte e detalhes técnicos',
    titulo: 'Fonte e detalhes técnicos',
    fonte: 'Fonte',
    vazio: 'Sem detalhes técnicos registrados para esta linha.',
  },
  rodape: {
    limite: 'Limite do método',
  },
  vinculo: {
    titulo: 'Vínculo do carimbo do tempo ao registro de evidências',
    subtitulo:
      'Cada carimbo do caso pareado pelo resumo que ele protege, nunca pelo nome do arquivo, e as verificações executadas, com o estado e o que foi comparado.',
    carimbo: 'Carimbo {carimbo}',
    coberto: 'Cobre o arquivo {arquivo}.',
    semPar: 'O resumo carimbado não é o de nenhum dos arquivos testados.',
    testados: 'Arquivos testados',
    instante: 'Instante do carimbo: {instante}.',
    consolidado: 'Resultado',
    colunas: {
      verificacao: 'Verificação',
      estado: 'Estado',
      registro: 'Motivo e valores comparados',
    },
  },
  estadoVct: {
    confere: 'Confere',
    nao_confere: 'Não confere',
    nao_verificado: 'Não verificado',
    nao_se_aplica: 'Não se aplica',
    alerta: 'Alerta',
  },
  consolidado: {
    confere: 'Confere',
    nao_confere: 'Não confere',
    alerta: 'Com alerta',
    nao_verificado: 'Com verificação não executada',
    nao_vinculado: 'Não vinculado',
  },
} as const;
